import { render } from "./RecentFeedbacks.vue?vue&type=template&id=6d003a58"
import script from "./RecentFeedbacks.vue?vue&type=script&lang=js"
export * from "./RecentFeedbacks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__